/** True when the viewport is at the mobile breakpoint where the workspace panes
 * stack (list ⇄ detail) instead of sitting side by side. Kept in sync with the
 * `@media (max-width: 720px)` block in ui/collab.css. */
export function isMobileViewport(): boolean {
  return typeof window !== "undefined" && window.matchMedia("(max-width: 720px)").matches;
}
